import { AfpRepository } from "../repositories/Afp.repository";

export const AfpService = {
    getAfpType,
}

async function getAfpType(){
    const res = await AfpRepository.getAfpType();
    return res;
}